// extracted by mini-css-extract-plugin
export default {"qrContainer":"styles-module__qrContainer__src-labstep-web-components-PermaLink-Reader-_vNZo2"};